import { Stack, CircularProgress, Typography, Box } from "@mui/material"
import { useTranslation } from "react-i18next"

interface NewCardInfoProps {
  isLoading: boolean
  cardPrice?: { price: number; currencySymbol: string }
}

const NewCardInfo = ({ isLoading, cardPrice }: NewCardInfoProps) => {
  const { t } = useTranslation()
  if (isLoading)
    return (
      <Stack direction="row" alignItems="center" spacing={1}>
        <CircularProgress size={20} />
        <Typography variant="caption">
          {t("passHolderDetails.form.cardPriceloading")}
        </Typography>
      </Stack>
    )

  if (!cardPrice) return

  return (
    <Typography component="div" variant="body3">
      {t("passHolderDetails.form.newCardInfoBefore")}{" "}
      <Box component="span" fontWeight="bold">
        ({cardPrice.price} {cardPrice.currencySymbol})
      </Box>{" "}
      {t("passHolderDetails.form.newCardInfoAfter")}
    </Typography>
  )
}

export default NewCardInfo
